import { message } from "antd"
import i18n from "../i18n"

function presentConnectionErrorMessage(error?: Error | string) {
  if (error instanceof Error) error = error.message
  if (!error) error = i18n["app.connectionError"]
  message.error(error)
}

export default presentConnectionErrorMessage